export const zodiac_mystic = [
  { char: '🔮', name: 'Crystal Ball', nameZh: '占卜/預測', keywords: ['future', 'magic', 'luck', '運勢'], hot: true },
  { char: '🧿', name: 'Nazar', nameZh: '開運/守護', keywords: ['protect', 'blue', 'lucky'], hot: true },
  { char: '🕯️', name: 'Candle', nameZh: '祭壇/氛圍', keywords: ['light', 'relax', 'mystic'] },
  { char: '✨', name: 'Sparkles', nameZh: '能量/魔法', keywords: ['magic', 'energy', 'shine'], hot: true },
  { char: '🌙', name: 'Crescent Moon', nameZh: '月相/直覺', keywords: ['night', 'dream', 'intuition'] },
  { char: '♈', name: 'Aries', nameZh: '牡羊座', keywords: ['zodiac', 'star'] },
  { char: '♉', name: 'Taurus', nameZh: '金牛座', keywords: ['zodiac', 'star'] },
  { char: '♊', name: 'Gemini', nameZh: '雙子座', keywords: ['zodiac', 'star'] },
  { char: '♋', name: 'Cancer', nameZh: '巨蟹座', keywords: ['zodiac', 'star'] },
  { char: '♌', name: 'Leo', nameZh: '獅子座', keywords: ['zodiac', 'star'] },
  { char: ' Virgo', char: '♍', name: 'Virgo', nameZh: '處女座', keywords: ['zodiac', 'star'] },
  { char: '♎', name: 'Libra', nameZh: '天秤座', keywords: ['zodiac', 'star'] },
  { char: '♏', name: 'Scorpio', nameZh: '天蠍座', keywords: ['zodiac', 'star'] },
  { char: '♐', name: 'Sagittarius', nameZh: '射手座', keywords: ['zodiac', 'star'] },
  { char: '♑', name: 'Capricorn', nameZh: '摩羯座', keywords: ['zodiac', 'star'] },
  { char: '♒', name: 'Aquarius', nameZh: '水瓶座', keywords: ['zodiac', 'star'] },
  { char: '♓', name: 'Pisces', nameZh: '雙魚座', keywords: ['zodiac', 'star'] },
  { char: '🃏', name: 'Joker', nameZh: '塔羅/牌卡', keywords: ['card', 'game', 'destiny'] },
];